import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  eventListDataLoading: false,
  eventListDataSuccess: null,
  eventListDataError: '',
}

export const gallerySlice = createSlice({
  name: 'Gallery',
  initialState,
  reducers: {

    setEventListDataLoading: (state, action) => {
      state.eventListDataLoading = true
      state.eventListDataSuccess = null
      state.eventListDataError = ''
    },
    setEventListDataSuccess: (state, action) => {
      state.eventListDataLoading = false
      state.eventListDataSuccess = action.payload
      state.eventListDataError = ''
    },
    setEventListDataError: (state, action) => {
      state.eventListDataLoading = false
      state.eventListDataSuccess = null
      state.eventListDataError = action.payload
    },

    resetEventData: (state) => {
      state.setEventListDataSuccess = null;
    }
  },
})

// Action creators are generated for each case reducer function
export const {
  setEventListDataLoading, setEventListDataSuccess, setEventListDataError, resetEventData,

} = gallerySlice.actions

export default gallerySlice.reducer;
